import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "egress-calculator",
  class EgressCalculator extends WYATTElement {
    constructor() {
      super();

      this.width = this.querySelector("[data-width]");
      this.height = this.querySelector("[data-height]");
      this.area = this.querySelector("[data-area]");

      this.subscribe(
        WYATT.config.pubsub.events.customizerFormUpdate,
        this.update.bind(this),
      );
    }

    update(formData) {
      const clearWidth = formData.get("width") - 4.25;
      const clearHeight = formData.get("height") - 5.625;
      const clearArea =
        Math.round(((clearWidth * clearHeight) / 144) * 100) / 100;

      this.width.textContent = clearWidth;
      this.height.textContent = clearHeight;
      this.area.textContent = clearArea;
    }
  },
);
